/* eslint-disable no-param-reassign */
import produce from 'immer';

const SET_APP_FEATURES = 'SET_APP_FEATURES';

const setAppFeatures = payload => ({
  type: SET_APP_FEATURES,
  payload,
});

const reducer = (
  state = {
    featuresList: {
      loaded: false,
      features: [],
    },
  },
  action
) =>
  produce(state, draft => {
    switch (action.type) {
      case SET_APP_FEATURES:
        draft.featuresList = action.payload;
        break;

      default:
        break;
    }
  });

export { reducer, setAppFeatures };
